export default "__VITE_PUBLIC_ASSET__94b3e993__"